import { Button, Form, Input, message } from 'antd'
import { useState, Fragment, useImperativeHandle } from 'react'
import { Modal } from 'antd'
import User from '@/modules/user'
import styles from './changePwd.scss'
import { SYSCON } from '@/const/const'

const ChangePwd = (props) => {
  // 属性
  const { handleForgetClick } = props
  const [modalVisible, handleModalVisible] = useState(false)
  const [formPwd] = Form.useForm()
  // 用户初始化
  const user = new User()

  const layout = {
    labelCol: { span: 5 },
    wrapperCol: { span: 19 }
  }

  const tailLayout = {
    wrapperCol: { offset: 8, span: 16 }
  }

  // 用useImperativeHandle暴露一些外部ref能访问的属性
  useImperativeHandle(props.onRef, () => {
    return {
      open
    }
  })
  const open = () => {
    handleModalVisible(true)
  }

  // 处理找回密码
  const onFinish = async(values) => {
    user.updPwd(values).then(()=>{
      message.success('修改成功')
      // 移除密码修改弹窗打开标志
      localStorage.removeItem(SYSCON.GelFinanceChangePws)
      setTimeout(()=>{
        handleModalVisible(false)
      }, 300)
    }).catch((err)=>{
      console.log('error', err)
    })
  }

  const passwordValid = ({ getFieldValue }) => ({
    validator(_, value) {
      if (!value || getFieldValue('newPwd') === value) {
        return Promise.resolve()
      }
      return Promise.reject(new Error('两次输入密码不一致!'))
    }
  })

  const cnInputCheck = (event) => {
    return event.target.value.replace(/[\u4E00-\u9FA5]/g, '').replace(/\s/g, '')
  }
  const validatePwd = () => ({
    validator(_, value) {
      if (value) {
        const reg = new RegExp('^(?![A-Z]*$)(?![a-z]*$)(?![0-9]*$)(?![^a-zA-Z0-9]*$)\\S+$')
        const cnReg = new RegExp('[\\u4E00-\\u9FFF]+', 'g')
        if (value && (value.length < 8 || value.length > 35)) {
          return Promise.reject(new Error('请输入8到35位的密码'))
        }
        if (!(reg.test(value)) || (cnReg.test(value))) {
          return Promise.reject(new Error('密码需数字、字母小写、字母大写、字符两种及以上组合'))
        } else {
          return Promise.resolve()
        }
      } else {
        return Promise.reject('请输入密码')
      }
    }
  })
  // 忘记密码
  const handleForget = ()=>{
    handleForgetClick()
    // 关闭弹窗
    handleModalVisible(false)
    // 移除token
    localStorage.removeItem(SYSCON.Token)
    // 移除密码修改弹窗打开标志
    localStorage.removeItem(SYSCON.GelFinanceChangePws)
    // 更新图标
    props.setStatu(user.getLoginStatu())
  }
  return (
    <Fragment>
      <Modal
        destroyOnClose
        centered
        title='登录密码修改'
        visible={modalVisible}
        onCancel={() => handleModalVisible(false)}
        closable={false}
        maskClosable={false}
        keyboard={false}
        footer={null}
        width={460}
        zIndex={3333333333}
      >
        <div className={styles['warningClass']}>您当前的登录密码强度较弱，为保证您的账户安全，请立即修改密码</div>
        <Form
          form={formPwd}
          {...layout}
          onFinish={onFinish}
          name='normal_login'
          className={styles['login-form']}
        >

          <Form.Item
            label='原密码'
            name='oldPwd'
            rules={[
              { required: true, message: '原密码不能为空' },
              { min: 6, max: 35, message: '请输入8-35位字符登录密码' }
            ]}
            getValueFromEvent = {cnInputCheck}
          >
            <Input.Password
              onCopy={(e) => e.preventDefault()}
              placeholder='请输入原密码'
            />
          </Form.Item>
          <Form.Item
            label='新密码'
            name='newPwd'
            rules={[
              { required: true, message: '新密码不能为空' },
              validatePwd
            ]}
            getValueFromEvent = {cnInputCheck}
          >
            <Input.Password onCopy={(e) => e.preventDefault()} placeholder='请输入8-35位字符登录密码' />
          </Form.Item>
          <Form.Item
            label='确认密码'
            name='cnewPwd'
            rules={[
              { required: true, message: '确认密码不能为空' },
              passwordValid
            ]}
            getValueFromEvent = {cnInputCheck}
          >
            <Input.Password onCopy={(e) => e.preventDefault()} placeholder='请输入8-35位字符登录密码' />
          </Form.Item>
          <Form.Item className={styles['forgot-password']}>
            <a className={styles['login-form-forgot']} onClick={() => handleForget()}>
              忘记密码？
            </a>
          </Form.Item>
          <Form.Item {...tailLayout}>
            <Button className={styles['login-form-forgot']} type='primary' htmlType='submit' >
              确定
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </Fragment>
  )
}

export default ChangePwd
